import React, { useEffect } from 'react'
import { Navigate, useNavigate, useLocation } from 'react-router-dom'

import { baseRoutes } from 'constants/routes'

import { useAuth } from 'utils/providers/AuthProvider'

import ProfileForm from 'components/ProfileForm'

import { getDirectionLink, removeDirectionLink, addDirectionLink } from 'shared'
import ProfileFormThankYou from 'components/ProfileForm/ProfileFormThankYou'

export interface IPrivateRouteProps {
  children: React.ReactElement
}

const PrivateRoute = ({ children }: IPrivateRouteProps) => {
  const { user, isUserFetching, userId } = useAuth()

  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const directionLink = getDirectionLink()
    const isDirectionLink = directionLink?.length && directionLink !== '/'
    if (isDirectionLink) {
      navigate(directionLink)
      removeDirectionLink()
    } else if (location.pathname === '/') {
      navigate(baseRoutes.campaigns)
    }
  }, [])

  useEffect(() => {
    const directionLink = getDirectionLink()
    if (!userId && !directionLink) {
      addDirectionLink(location.pathname)
    }
  }, [userId])

  if (!user && isUserFetching) {
    return null
  }

  if (user && userId) {
    if (!user.profile.isVerified) {
      return <ProfileForm />
    } else if (user.statusId !== 2) {
      return <ProfileFormThankYou />
    }
    return children
  }

  return <Navigate to={baseRoutes.login} />
}

export default PrivateRoute
